import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import CartDrawer from './components/CartDrawer'
import { CartProvider } from './context/CartContext'

// Pages
import Home from './pages/Home'
import HelstegtPattegrisPage from './pages/HelstegtPattegrisPage'
import CateringPage from './pages/CateringPage'
import MadUdAfHusetPage from './pages/MadUdAfHusetPage'
import FestUdlejningPage from './pages/FestUdlejningPage'
import OrderGuidePage from './pages/OrderGuidePage'
import AboutPage from './pages/AboutPage'
import TermsPage from './pages/TermsPage'
import ContactPage from './pages/ContactPage'
import NotFoundPage from './pages/NotFoundPage'
import ForbiddenPage from './pages/ForbiddenPage'

export default function App() {
  return (
    <CartProvider>
      <div className="min-h-screen flex flex-col bg-white text-[#241F1C]">
        {/* Scroll restoration on route changes */}
        <ScrollToTop />

        {/* Global Header */}
        <Navbar />

        {/* Global Cart Slide-over */}
        <CartDrawer />

        {/* Main Content Area */}
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/helstegt-pattegris" element={<HelstegtPattegrisPage />} />
            <Route path="/catering" element={<CateringPage />} />
            <Route path="/mad-ud-af-huset" element={<MadUdAfHusetPage />} />
            <Route path="/fest-og-udlejning" element={<FestUdlejningPage />} />
            <Route path="/udlejning" element={<FestUdlejningPage />} />
            <Route path="/bestil" element={<OrderGuidePage />} />
            <Route path="/menu-guide" element={<OrderGuidePage />} />
            <Route path="/om-os" element={<AboutPage />} />
            <Route path="/salgs-og-leveringsbetingelser" element={<TermsPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        {/* Global Footer */}
        <Footer />
      </div>
    </CartProvider>
  )
}
